module.exports = __webpack_public_path__ + "images/buttons/cancel_yellow_bg.gif";